<template>
  <div class="bar_chart_horizontal section">
    <canvas id="bar_horizontal" width="400" height="400"></canvas>
  </div>
</template>

<script>
// @ is an alias to /src

import Chart from "chart.js";
import herb from "@/assets/icons/icons_general/icon_herb.svg";
import flower from "@/assets/icons/icons_general/icon_flower.svg";
import apple from "@/assets/icons/icons_general/fruits.png";
import broccoli from "@/assets/icons/icons_general/icon_broccoli.svg";
import seed from "@/assets/icons/icons_general/icon_seeds.svg";
import potato from "@/assets/icons/icons_general/icon_potatoes.svg";
import { mapState } from "vuex";

export default {
  name: "bar_chart_horizontal",
  data() {
    return {
      chart: "",
    };
  },
  components: {},
  computed: {
    ...mapState({
      horizental_chart: (state) => {
        return state.dashboardModule.horizental_chart_be;
      },
    }),
  },
  methods: {
    chartOption(valueDataset) {
      return {
        responsive: true,
        events: false,
        showTooltips: false,
        legend: {
          display: false,
        },
        animation: {
          onComplete: function () {
            let ctx = this.chart.ctx;
            ctx.font = Chart.helpers.fontString(
              Chart.defaults.global.defaultFontFamily,
              "normal",
              Chart.defaults.global.defaultFontFamily
            );
            ctx.textAlign = "left";
            ctx.textBaseline = "top";
            this.data.datasets.forEach(function (dataset) {
              for (let i = 0; i < dataset.data.length; i++) {
                let currentValue = valueDataset[i];
                let model =
                  dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
                ctx.fillStyle = "#DB7F50";
                ctx.fillText(currentValue + "%", model.x - 40, model.y - 25);
              }
            });
          },
        },
        layout: {
          padding: {
            left: 20,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                stepSize: 20,
                padding: 20,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      };
    },

    async prepareData(value) {
      let values = [];
      let labels = [];
      let percent = [];
      await Object.keys(value).forEach((key) => {
        const item = value[key];
        labels.push(item.name);
        values.push(item.value);
      });
      await values.forEach((item) => {
        let sum = values.reduce(function (previousValue, currentValue) {
          return previousValue + currentValue;
        });
        let currentValue = item;
        let precentage = parseFloat((currentValue / sum) * 100).toFixed(2);
        percent.push(precentage);
      });
      return { percent: percent, labels: labels };
    },

    async updateValue(newValue) {
      let data = await this.prepareData(newValue);
      const percent = data.percent;
      const labels = data.labels;
      this.chart.data.datasets[0].data = percent;
      this.chart.data.labels = labels;
      this.chart.options = this.chartOption(percent);
      this.chart.update();
    },
  },
  async mounted() {
    this.$store.watch(
      (state) => {
        return state.dashboardModule.horizental_chart_be;
      },
      (newValue, oldValue) => {
        this.updateValue(newValue);
      }
    );
    let data = await this.prepareData(this.horizental_chart);
    const percent = data.percent;
    const labels = data.labels;
    const images = [potato, apple, broccoli, herb, flower, seed];
    this.chart = new Chart(document.getElementById("bar_horizontal"), {
      type: "horizontalBar",
      plugins: [
        {
          afterDraw: (chart) => {
            let ctx = chart.chart.ctx;
            let xAxis = chart.scales["x-axis-0"];
            let yAxis = chart.scales["y-axis-0"];
            xAxis.ticks.forEach((value, index) => {
              let y = yAxis.getPixelForTick(index);
              let image = new Image();
              (image.src = images[index]), ctx.drawImage(image, 80, y - 13);
            });
          },
        },
        {
          afterLayout: (chart) => {
            let ctx = chart.chart.ctx;
            ctx.save();
            let yAxis = chart.scales["y-axis-0"];
            let yBottom = yAxis.getPixelForValue(0);
            let yTop = yAxis.getPixelForValue(5);
            let gradient = ctx.createLinearGradient(0, yBottom, 0, yTop);
            gradient.addColorStop(0, "#E9A37F");
            gradient.addColorStop(1, "#DB7F50");
            chart.data.datasets[0].backgroundColor = gradient;
            ctx.restore();
          },
        },
      ],
      data: {
        labels: labels,
        datasets: [
          {
            label: "My Dataset",
            data: percent,
            fill: false,
            barThickness: 20,
          },
        ],
      },
      options: this.chartOption(percent),
    });
  },
};
</script>
<style lang="scss">
.bar_chart_horizontal {
  height: 400px !important;
}
</style>
